import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns';
import { ProjectStatus } from './ProjectStatus';
import ProjectStatusCell from '@/components/projects/ProjectStatusCell';
import { Translator } from '../translator.type';

export type Project = {
  id: string;
  name: string;
  clientFirstName?: string | null;
  nbEstimations?: number;
  _count: {
    adults: number;
    children: number;
    estimates: number;
  };
  status: ProjectStatus;
  reservationAgent: {
    id: string;
    firstname: string;
    lastname: string;
  };
  createdAt: string;
};

export const getProjectsColumnDef = (
  t: Translator,
  isTourOperator: boolean,
): ColumnDef<Project>[] => [
  ...(isTourOperator
    ? [
        {
          accessorKey: 'name',
          header: t('distributorProjects.columns.name'),
        },
        {
          accessorKey: 'clientFirstName',
          header: t('distributorProjects.columns.firstName'),
          cell: ({ row }: { row: { original: Project } }) => (
            <span>{row.original.clientFirstName ?? '-'}</span>
          ),
        },
      ]
    : [
        {
          accessorKey: 'name',
          header: t('project.columns.name'),
        },
      ]),
  {
    accessorKey: '_count.estimates',
    header: t('project.columns.estimates'),
  },
  {
    accessorKey: '_count.adults',
    header: t('project.columns.adults'),
  },
  {
    accessorKey: '_count.children',
    header: t('project.columns.children'),
  },
  {
    accessorKey: 'reservationAgent.firstname',
    header: t('project.columns.agent'),
    cell: ({
      row: {
        original: {
          reservationAgent: { firstname, lastname },
        },
      },
    }) => <span>{`${firstname} ${lastname}`}</span>,
  },
  {
    accessorKey: 'createdAt',
    header: t('project.columns.createdAt'),
    cell: ({ row }) => (
      <span>{format(row.original.createdAt, 'dd/MM/yyyy')}</span>
    ),
  },
  {
    accessorKey: 'status',
    header: t('project.columns.status'),
    cell: ({ row }) => <ProjectStatusCell status={row.original.status} />,
  },
];

/** @deprecated Use getProjectsColumnDef(t, false) */
export const PROJECTS_COLUMN_DEF = (t: Translator) =>
  getProjectsColumnDef(t, false);
